import ROUTES from '../routes';
import CashCollection from '../hoc/cash-collection/cash-collection';
import CashCollectionTransaction from '../hoc/cash-collection/item';
import CreateCashCollection from '../hoc/cash-collection/create';
import CashCollectionList from '../hoc/cash-collection/list';
import CashCollectionOrders from '../hoc/cash-collection/oders';
import CashCollectionBeneficiaryOrder from '../hoc/cash-collection/beneficiary-order';

const CashCollectionRoutes = {
  path: ROUTES.CASH_COLLECTION,
  element: <CashCollection />,
  children: [
    {
      path: ROUTES.CASH_COLLECTION_LIST,
      element: <CashCollectionList />,
      children: [
        {
          path: ROUTES.CASH_COLLECTION_TRANSACTION,
          element: (
            <CashCollectionTransaction backPath={ROUTES.CASH_COLLECTION_LIST} />
          ),
        },
        {
          path: ROUTES.CASH_COLLECTION_CREATE,
          element: <CreateCashCollection />,
        },
      ],
    },
    {
      path: ROUTES.CASH_COLLECTION_ORDERS,
      element: <CashCollectionOrders />,
      children: [
        {
          path: ROUTES.CASH_COLLECTION_ORDER,
          element: (
            <CashCollectionTransaction
              backPath={ROUTES.CASH_COLLECTION_ORDERS}
            />
          ),
        },
        {
          path: ROUTES.CASH_COLLECTION_BENEFICIARY_ORDER,
          element: <CashCollectionBeneficiaryOrder />,
        },
      ],
    },
  ],
};

export default CashCollectionRoutes;
